import OrderContactInfoWrapper from '../CheckoutPage/OrderContactInfo/OrderContactInfoWrapper';
import OrderContactOverview from '../CheckoutPage/OrderContactInfo/OrderContactOverview';
import MarketingPreferencesWrapper from '../CheckoutPage/MarketingPreferences/MarketingPreferencesWrapper';
import OrderSubmitLegalTermsWrapper from '../CheckoutPage/OrderSubmitLegalTerms/OrderSubmitLegalTermsWrapper';
import SubmitButtonWrapper from '../CheckoutPage/SubmitButton/SubmitButtonWrapper';
import HandlePXPPayment from '../Common/PXP/HandlePXPPayment';
import CheckoutSelectedStore from '../CheckoutPage/CheckoutSelectedStore';
import PaymentManager from '../CheckoutPage/PaymentManager/PaymentManager';
import DeliveryOverview from '../CheckoutPage/DeliveryOptions/DeliveryOverview';
import PaymentOverview from '../CheckoutPage/PaymentManager/PaymentOverview';
import MobileCheckoutRightRailWrapper from './MobileCheckoutRightRailWrapper';
import FooterRightRailWrapper from '../CheckoutPage/FooterRightRailWrapper';
import {
  RepudiationWrapper,
  DeliveryOptionsWrapper,
  ShippingSpeedWrapper,
  ShippingHandlingContainerWrapper,
  ShippingAddressWrapper,
  PudosSectionWrapper,
  PopinsSectionWrapper,
  GooglePayWrapper,
  ApplePayWrapper,
  KlarnaWrapper,
  PayPalWrapper,
  PickupOrderWrapper,
  CheckoutSelectedStoreWrapper,
  BagListWrapper,
} from '../CheckoutPage/StepComponentWrappers';

export default {
  OrderContactInfoWrapper,
  OrderContactOverview,
  DeliveryOverview,
  RepudiationWrapper,
  DeliveryOptionsWrapper,
  ShippingSpeedWrapper,
  ShippingAddressWrapper,
  ShippingHandlingContainerWrapper,
  PudosSectionWrapper,
  PopinsSectionWrapper,
  GooglePayWrapper,
  ApplePayWrapper,
  KlarnaWrapper,
  PayPalWrapper,
  HandlePXPPayment,
  CheckoutSelectedStore,
  PaymentManager,
  MarketingPreferencesWrapper,
  OrderSubmitLegalTermsWrapper,
  SubmitButtonWrapper,
  PaymentOverview,
  MobileCheckoutRightRailWrapper,
  PickupOrderWrapper,
  CheckoutSelectedStoreWrapper,
  BagListWrapper,
  FooterRightRailWrapper,
};
